import type {
  GetInferencePriceParams,
  GetInferencePricesParams,
  InferencePrice,
  InferencePriceResponse,
  InferencePricesResponse,
} from '@famecreator/shared-types/inference-price';

import { ENV } from '@/shared/config/env';
import { logger } from '@/shared/lib/logger';

import { apiClient } from './client';
import { INFERENCE_PRICES_QUERY, INFERENCE_PRICE_QUERY } from './graphql/queries/inference-price';

class InferencePriceService {
  /**
   * Get inference price for specific parameters
   */
  async getInferencePrice(params: GetInferencePriceParams): Promise<InferencePrice | null> {
    try {
      const response = await apiClient.post<{ data: InferencePriceResponse }>('/graphql', {
        query: INFERENCE_PRICE_QUERY,
        variables: params,
      });

      return response.data?.data?.inferencePrice || null;
    } catch (error: unknown) {
      logger.api.error('Error fetching inference price', { error, params });
      throw error;
    }
  }

  /**
   * Get all available inference prices with optional filters
   */
  async getInferencePrices(params?: GetInferencePricesParams): Promise<InferencePrice[]> {
    try {
      const variables = {
        ...params,
        nsfw: ENV.NSFW,
      };

      const response = await apiClient.post<{ data: InferencePricesResponse }>('/graphql', {
        query: INFERENCE_PRICES_QUERY,
        variables,
      });

      return response.data?.data?.inferencePrices || [];
    } catch (error: unknown) {
      logger.api.error('Error fetching inference prices', { error, params });
      throw error;
    }
  }
}

export const inferencePriceService = new InferencePriceService();
